import { render } from "./ExternalDoc.vue?vue&type=template&id=3232bc6a&scoped=true"
import script from "./ExternalDoc.vue?vue&type=script&lang=js"
export * from "./ExternalDoc.vue?vue&type=script&lang=js"

import "./ExternalDoc.vue?vue&type=style&index=0&id=3232bc6a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3232bc6a"]])

export default __exports__